webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return intervalSDK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return webcam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return startCamera; });
var intervalSDK = -1;
var webcam = void 0;

var draw = brfv4.example.drawing;
var dom = brfv4.example.dom;
var _images = [];
var _image = null;
var _baseNode = new createjs.Container();
var _position = new brfv4.Point();
var calcDistance = brfv4.BRFv4PointUtils.calcDistance;
var calcAngle = brfv4.BRFv4PointUtils.calcAngle;
var toDegree = brfv4.BRFv4PointUtils.toDegree;

function startCamera() {
  var tracking = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var timeoutWebcam = -1;
  webcam = document.getElementById('_webcam' + tracking);

  function onStreamFetched(mediaStream) {
    webcam.srcObject = mediaStream;
    webcam.play();

    function onStreamDimensionsAvailable() {
      if (webcam.videoWidth === 0) {
        clearTimeout(timeoutWebcam);
        timeoutWebcam = setTimeout(onStreamDimensionsAvailable, 100);
      } else {
        initBRF(619, 389, tracking);
      }
    }

    onStreamDimensionsAvailable();
  }

  window.navigator.mediaDevices.getUserMedia({
    video: {
      width: {
        min: 640,
        ideal: 1280,
        max: 1920
      },
      height: {
        min: 480,
        ideal: 720,
        max: 1080
      }
    }
  }).then(onStreamFetched).catch(function () {});

  function changeImage(bitmap, index) {
    var imageFactor = 1.0;

    if (index === 0) {
      imageFactor = 1.0;
    } else if (index === 1) {
      imageFactor = 3.3;
    }

    bitmap.scaleX = imageFactor;
    bitmap.scaleY = imageFactor;

    bitmap.x = -parseInt(bitmap.getBounds().width * bitmap.scaleX * 0.50, 10);
    bitmap.y = -parseInt(bitmap.getBounds().height * bitmap.scaleY * 0.45, 10);

    _baseNode.removeAllChildren();
    _baseNode.addChild(bitmap);
  }

  function initBRF(width, height, tracking) {
    draw.setup(dom.getElement('_drawing' + tracking), dom.getElement('_faceSub' + tracking), 30);

    draw.imageContainer.addChild(_baseNode);
    var _imageURLs = ['/static/img/img_glasses.png'];

    _image = new createjs.Bitmap(_imageURLs[0]);

    if (tracking === 0) {
      _image.image.onload = function onload() {
        changeImage(_image);
      };
    }

    dom.updateLayout(width, height);
    draw.updateLayout(width, height);
    var imageData = document.getElementById('_imageData' + tracking);

    imageData.width = width;
    imageData.height = height;
    imageData.style.position = "absolute";

    var imageDataCtx = imageData.getContext('2d');

    var brfManager = new brfv4.BRFManager();
    var resolution = new brfv4.Rectangle(0, 0, width, height);

    var timeoutSDK = -1;

    function waitForSDK() {
      if (brfv4.sdkReady) {
        onReadySDK();
      } else {
        clearTimeout(timeoutSDK);
        timeoutSDK = setTimeout(waitForSDK, 100);
      }
    }

    function onReadySDK() {
      initSDK();
    }

    function initSDK() {
      if (!brfv4.sdkReady) waitForSDK();else brfManager.init(resolution, resolution, "com.tastenkunst.brfv4.js.examples.minimal.webcam");

      intervalSDK = setInterval(update, 1000 / 30);
    }

    var measures = [{
      name: "Head to chin",
      i: 19,
      j: 8,
      measures: []
    }, {
      name: "Head to pupil",
      i: 19,
      j: 38,
      measures: []
    }, {
      name: "Pupil to nosetip",
      i: 38,
      j: 33,
      measures: []
    }, {
      name: "Pupil to lip",
      i: 41,
      j: 66,
      measures: []
    }, {
      name: "Width of nose",
      i: 31,
      j: 35,
      measures: []
    }, {
      name: "Outside distance between eyes",
      i: 36,
      j: 45,
      measures: []
    }, {
      name: "Width of head",
      i: 0,
      j: 16,
      measures: []
    }, {
      name: "Hairline to pupil",
      i: 36,
      j: 0,
      measures: []
    }, {
      name: "Nosetip to chin",
      i: 33,
      j: 8,
      measures: []
    }, {
      name: "Lips to chin",
      i: 66,
      j: 8,
      measures: []
    }, {
      name: "Length of lips",
      i: 48,
      j: 54,
      measures: []
    }, {
      name: "Nosetip to lips",
      i: 33,
      j: 66,
      measures: []
    }];

    function update() {
      imageDataCtx.setTransform(-1.0, 0, 0, 1, resolution.width, 0);
      imageDataCtx.drawImage(webcam, 0, 0, resolution.width, resolution.height);
      imageDataCtx.setTransform(1.0, 0, 0, 1, 0, 0);

      brfManager.update(imageDataCtx.getImageData(0, 0, resolution.width, resolution.height).data);
      draw.clear();

      var faces = brfManager.getFaces();

      var showBaseNode = false;

      for (var _i = 0; _i < faces.length; _i += 1) {
        var face = faces[_i];

        if (face.state === brfv4.BRFState.FACE_TRACKING_START || face.state === brfv4.BRFState.FACE_TRACKING) {
          switch (tracking) {
            case 1:
              {

                draw.drawTriangles(face.candideVertices, face.candideTriangles, false, 1.0, 0xffd200, 0.4, 0, 0);
                draw.drawTrianglesAsPoints(face.candideVertices, 2.0, false, 0xffd200, 0.4);

                draw.drawTriangles(face.vertices, face.triangles, false, 1.0, 0x00a0ff, 0.4, 0, 0);
                draw.drawTrianglesAsPoints(face.vertices, 2.0, false, 0x00a0ff, 0.4);

                var ctx = draw.faceTextures.getContext("2d");
                ctx.strokeStyle = "white";
                ctx.lineWidth = 2;
                ctx.fillStyle = "gold";
                ctx.font = "13px Arial";
                var bottom = (face.points[48].y + face.points[60].y) / 2;
                var bottomb = (face.points[7].y + face.points[9].y) / 2;
                var top = (face.points[36].y + face.points[45].y) / 2;

                var goldenRation = (bottom - top) / (bottomb - bottom);
                for (var _i = 0; _i < measures.length; _i++) {
                  var measure = measures[_i];
                  measure.measures.push(Math.sqrt(Math.pow(face.points[measure.j].x - face.points[measure.i].x, 2) + Math.pow(face.points[measure.j].y - face.points[measure.i].y, 2)));
                  if (measure.measures.length > 10) measure.measures.splice(0, 1);
                  var avg = Math.floor(measure.measures.reduce(function (a, c) {
                    return a + c;
                  }) / measure.measures.length) / 10;

                  ctx.fillText(measure.name + ": " + avg + " cm", 10, 15 + _i * 20);
                }
                break;
              }
            case 0:
              {

                _position.x = face.points[27].x;
                _position.y = face.points[27].y;

                var leftEye = face.points[36];
                var rightEye = face.points[45];

                var dist = calcDistance(leftEye, rightEye);
                var rot = toDegree(calcAngle(leftEye, rightEye));
                var scale = dist * 0.0026;

                _baseNode.rotation = 0;
                _baseNode.x = _position.x;
                _baseNode.y = _position.y;
                _baseNode.rotation = rot;

                _baseNode.scaleX = scale * (1 - toDegree(Math.abs(face.rotationY)) / 150.0);
                _baseNode.scaleY = scale * (1 - toDegree(Math.abs(face.rotationX)) / 100.0);
                _baseNode.alpha = 1.0;

                showBaseNode = true;
                break;
              }
            case 2:
              {
                break;
              }
          }
        }
      }

      if (!showBaseNode) {
        _baseNode.alpha = 0.0;
      }
    }

    initSDK();
  }
}



/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Showcase__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Showcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Showcase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Luxy__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Luxy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Luxy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Selection__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Selection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Selection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Selfie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Selfie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Selfie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pre0__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pre0___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Pre0__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Pre1__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Pre1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Pre1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pre2__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pre2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Pre2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Aft1__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Aft1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Aft1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Aft2__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Aft2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Aft2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Aft3__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Aft3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Aft3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Final__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Final___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Final__);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '*', redirect: '/pre-0' }, { path: '/pre-0', name: 'pre-0', component: __WEBPACK_IMPORTED_MODULE_6__components_Pre0___default.a }, { path: '/pre-1', name: 'pre-1', component: __WEBPACK_IMPORTED_MODULE_7__components_Pre1___default.a }, { path: '/pre-2', name: 'pre-2', component: __WEBPACK_IMPORTED_MODULE_8__components_Pre2___default.a }, { path: '/final', name: 'final', component: __WEBPACK_IMPORTED_MODULE_12__components_Final___default.a }, { path: '/showcase', name: 'showcase', component: __WEBPACK_IMPORTED_MODULE_2__components_Showcase___default.a }, { path: '/luxy', name: 'luxy', component: __WEBPACK_IMPORTED_MODULE_3__components_Luxy___default.a }, { path: '/selection', name: 'selection', component: __WEBPACK_IMPORTED_MODULE_4__components_Selection___default.a }, { path: '/selfie', name: 'selfie', component: __WEBPACK_IMPORTED_MODULE_5__components_Selfie___default.a }, { path: '/aft-1', name: 'aft-1', component: __WEBPACK_IMPORTED_MODULE_9__components_Aft1___default.a }, { path: '/aft-2', name: 'aft-2', component: __WEBPACK_IMPORTED_MODULE_10__components_Aft2___default.a }, { path: '/aft-3', name: 'aft-3', component: __WEBPACK_IMPORTED_MODULE_11__components_Aft3___default.a }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_webcam__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'luxy',
  data: function data() {
    return {
      question: 0,
      step: 0,
      body: ''
    };
  },

  computed: {
    questionString: function questionString() {
      return 'active-question-' + this.question;
    },
    stepString: function stepString() {
      return 'step-' + this.step;
    }
  },
  created: function created() {
    setTimeout(function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["c" /* startCamera */])(1);
    }, 1000);
  },

  methods: {
    incrementQuestion: function incrementQuestion() {
      this.question += 1;
    },
    highlightGlasses: function highlightGlasses(e) {
      e && e.preventDefault();
      if (this.question === 0) {
        this.incrementQuestion();
      } else {
        this.destroyWebcam();

        this.step += 1;
        this.body = 'choice-done';
      }
    },
    destroyWebcam: function destroyWebcam() {
      if (__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["a" /* intervalSDK */] !== -1) {
        clearInterval(__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["a" /* intervalSDK */]);
      }

      if (__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["b" /* webcam */]) {
        __WEBPACK_IMPORTED_MODULE_0__libs_webcam__["b" /* webcam */].src = '';
        __WEBPACK_IMPORTED_MODULE_0__libs_webcam__["b" /* webcam */].play();
      }
    },
    goToSelfie: function goToSelfie() {
      this.$router.push('/selfie');
    }
  },
  watch: {
    question: function question(val) {
      if (val > 3) {
        this.$router.push('/selection');
      }
    },
    step: function step(val) {
      if (val > 1) this.$router.push('/selfie');
    }
  },
  destroyed: function destroyed() {
    this.destroyWebcam();
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'selection'
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_webcam__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: false,
      buy: false,
      confirmMail: false,
      emailaddress: ""
    };
  },

  computed: {
    showEmail: function showEmail() {
      return this.email ? 'visible' : 'hidden';
    },
    showBuy: function showBuy() {
      return this.buy ? 'visible' : 'hidden';
    },
    showConfirmMail: function showConfirmMail() {
      return this.confirmMail ? 'visible' : 'hidden';
    }
  },
  methods: {
    addressEmail: function addressEmail() {
      if (__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["a" /* intervalSDK */] !== -1) {
        clearInterval(__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["a" /* intervalSDK */]);
      }

      this.buy = false;
      this.email = true;
    },
    sendEmail: function sendEmail() {
      this.email = false;
      var canvas = document.getElementById("_imageData2");
      var canvasData = canvas.toDataURL("image/png");
      var ajax = new XMLHttpRequest();
      ajax.open("POST", 'https://luxy.ga/post', true);
      ajax.onreadystatechange = function () {
        console.log(ajax.responseText);
      };
      function dataURItoBlob(dataURI) {
        var byteString = atob(dataURI.split(',')[1]);
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      }
      var formData = new FormData();
      formData.append("file", dataURItoBlob(canvasData), "MySelfie.png");

      ajax.setRequestHeader('X-Email', this.emailaddress);
      ajax.send(formData);
      this.confirmMail = true;
    },
    closeConfirmMail: function closeConfirmMail() {
      this.confirmMail = false;
    },
    sendOrder: function sendOrder() {
      this.email = false;
      this.buy = !this.buy;
    }
  },
  destroyed: function destroyed() {
    if (__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["a" /* intervalSDK */] !== -1) {
      clearInterval(__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["a" /* intervalSDK */]);
    }

    if (__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["b" /* webcam */]) {
      __WEBPACK_IMPORTED_MODULE_0__libs_webcam__["b" /* webcam */].src = '';
      __WEBPACK_IMPORTED_MODULE_0__libs_webcam__["b" /* webcam */].play();
    }
  },
  created: function created() {
    setTimeout(function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["c" /* startCamera */])(2);
    }, 1000);
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_webcam__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  destroyed: function destroyed() {
    if (__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["a" /* intervalSDK */] !== -1) {
      clearInterval(__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["a" /* intervalSDK */]);
    }

    if (__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["b" /* webcam */]) {
      __WEBPACK_IMPORTED_MODULE_0__libs_webcam__["b" /* webcam */].src = '';
      __WEBPACK_IMPORTED_MODULE_0__libs_webcam__["b" /* webcam */].play();
    }
  },
  created: function created() {
    setTimeout(function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__libs_webcam__["c" /* startCamera */])(0);
    }, 1000);
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(3);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */]
}).$mount('#app');

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(26),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(30),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(9)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(22),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(25),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(24),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(23),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(29),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(31),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(32),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.stepString,
    attrs: {
      "id": "background"
    }
  }, [_c('div', {
    class: _vm.stepString,
    attrs: {
      "id": "_content"
    }
  }, [_c('video', {
    staticClass: "video-webcam",
    attrs: {
      "id": "_webcam1"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_imageData1"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_faceSub1"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_threejs1"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_drawing1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-canvas",
    attrs: {
      "id": "glasses"
    }
  }, [_c('div', {
    staticClass: "choices",
    on: {
      "click": _vm.goToSelfie
    }
  }, [_vm._v("\n        Cosa ne pensi di questi?"), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata3/occhiale1.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata3/occhiale2.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata3/occhiale3.png"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer",
    on: {
      "click": _vm.goToSelfie
    }
  }, [_c('div', [_vm._v("Scatta!")])])])]), _vm._v(" "), _c('div', {
    class: _vm.questionString + ' ' + _vm.stepString,
    attrs: {
      "id": "question"
    },
    on: {
      "click": _vm.highlightGlasses
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/showcase",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/selfie",
      "event": '',
      "id": "nav-next"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.highlightGlasses()
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "influencer"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/schermata3/attanasio.png"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Vuoi vedere la scelta di @fabioattanasio?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n      Che cosa ti ispira? "), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata2/esperienza1.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata2/esperienza2.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata2/esperienza3.png"
    }
  })])
}]}

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": "/pre-1",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/showcase",
      "id": "nav-next"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": "/pre-0",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/pre-2",
      "id": "nav-next"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": "/pre-1",
      "id": "nav-next"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": "/selfie",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/aft-2",
      "id": "nav-next"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": "/aft-1",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/aft-3",
      "id": "nav-next"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": "/aft-2",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/final",
      "id": "nav-next"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": "/lux",
      "id": "nav-prev"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": "/aft-3",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/pre-0",
      "id": "nav-next"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/schermata4/btn-buy.png"
    },
    on: {
      "click": _vm.sendOrder
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata4/btn-live.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata4/btn-send.png"
    },
    on: {
      "click": _vm.addressEmail
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup",
    class: _vm.showEmail,
    attrs: {
      "id": "email"
    }
  }, [_c('h3', [_vm._v("Inserisci la tua email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailaddress),
      expression: "emailaddress"
    }],
    attrs: {
      "type": "email",
      "title": "email"
    },
    domProps: {
      "value": (_vm.emailaddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailaddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("Invia")])]), _vm._v(" "), _c('div', {
    staticClass: "popup",
    class: _vm.showConfirmMail,
    attrs: {
      "id": "confirmMail"
    }
  }, [_c('h3', [_vm._v("Email inviata!")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.closeConfirmMail
    }
  }, [_vm._v("Ok")])]), _vm._v(" "), _c('div', {
    staticClass: "popup",
    class: _vm.showBuy,
    attrs: {
      "id": "buy"
    }
  }, [_c('h3', [_vm._v("Grazie!")]), _vm._v(" "), _c('p', [_vm._v("I tuoi nuovi occhiali ti aspettano in cassa")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/luxy",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/aft-1",
      "id": "nav-next"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "_content"
    }
  }, [_c('div', [_c('video', {
    staticClass: "video-webcam",
    attrs: {
      "id": "_webcam2"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_imageData2"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_faceSub2"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_threejs2"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_drawing2"
    }
  })])])
}]}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/pre-2",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/luxy",
      "id": "nav-next"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "_content"
    }
  }, [_c('div', [_c('video', {
    staticClass: "video-webcam",
    attrs: {
      "id": "_webcam0"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_imageData0"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_faceSub0"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_threejs0"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_drawing0"
    }
  })])])
}]}

/***/ })
],[8]);


// WEBPACK FOOTER //
// static/js/app.40b21435f50780de188b.js